@if (configuracao?.usa_conta_corrente_flex) {
  <div class="saldos-flex">
    <div class="saldo-card"><span>Saldo disponível</span><strong>{{ contaCorrenteSaldoDisponivel | currency: 'BRL' }}</strong></div>
    <div class="saldo-card"><span>Saldo gerado</span><strong>{{ saldoGeradoValorFinal | currency: 'BRL' }}</strong></div>
    <ng-container [ngTemplateOutlet]="limiteDisponivel"></ng-container>
  </div>
}
@if (exibirPrazoPagamento || (!configuracao?.usa_conta_corrente_flex && clienteSelecionado?.limite_credito_disponivel != null)) {
<section class="condicoes-pagamento" aria-label="Condições de pagamento">
  @if (exibirPrazoPagamento) {
  <div class="prazo-pagamento"><span>Prazo de pagamento</span>
      <app-prazo-pagamento-select
        [prazosIniciais]="prazosPagamentoIniciais"
        [prazosEspeciais]="prazosPagamentoEspeciais"
        [prazoSelecionado]="prazoPagamentoSelecionado"
        [desabilitado]="clienteSelecionado == null || pedidoAprovarExterno || calculando"
        [invalido]="prazoPagamentoInvalido"
        [ocultarTitulosIniciais]="configuracao.flag_usa_prazo_vinculado_cliente"
        (prazoChange)="prazoAlterado.emit($event.toString())">
      </app-prazo-pagamento-select>
    @if (prazoPagamentoInvalido) { <small class="erro">Prazo de Pagamento inválido!</small> }
  </div>
  <div><span>Prazo médio</span><strong>{{ prazoMedio?.prazomedio ?? '—' }}</strong></div>
  }
  @if (!configuracao?.usa_conta_corrente_flex) { <ng-container [ngTemplateOutlet]="limiteDisponivel"></ng-container> }
  @if (exibirPrazoPagamento && configuracao?.usar_desconto_prazo_medio == 'S') {
    <div><span>Desconto máximo</span><strong>{{ prazoMedioDesconto == null ? '—' : (prazoMedioDesconto.percentual_desconto | number: '1.2-2') + '%' }}</strong></div>
  }
</section>
}
@if (clienteSelecionado?.limite_credito_cliente != null || clienteSelecionado?.limite_credito_utilizado != null) {
  <div class="credito-complementar">
    @if (clienteSelecionado?.limite_credito_cliente != null) { <span>Limite do cliente: <b>{{ clienteSelecionado.limite_credito_cliente | currency: 'BRL' }}</b></span> }
    @if (clienteSelecionado?.limite_credito_utilizado != null) { <span>Limite utilizado: <b>{{ clienteSelecionado.limite_credito_utilizado | currency: 'BRL' }}</b></span> }
  </div>
}
<ng-template #limiteDisponivel>
  @if (clienteSelecionado?.limite_credito_disponivel != null) {
    <div class="saldo-card limite-disponivel"><span>Limite disponível</span><strong>{{ clienteSelecionado.limite_credito_disponivel | currency: 'BRL' }}</strong></div>
  }
</ng-template>
